import { consultationStatus, useConsultation } from '@entities/consultations';
import type React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import {
	useBuyConsultation,
	useCancelConsultation,
	useConnect,
	useConsultationMessage,
} from '@features/consultations';

import { MoreHoriz } from '@shared/assets';
import { useMuiMenu, useUser } from '@shared/hooks';
import { IconButton } from '@shared/ui';

import { useModalCopyMessage } from '@src/features/common';

type Props = {
	id: number;
};

export const BuyerMenu: React.FC<Props> = ({ id }) => {
	const { isOpen, onOpen, onClose, anchorEl } = useMuiMenu();
	const { code } = useParams<{ code: string }>();
	const navigate = useNavigate();
	const { consultation } = useConsultation(id);
	const { onConnect } = useConnect(id);
	const { onBuy } = useBuyConsultation(id);
	const { onCancel } = useCancelConsultation(id);

	const { user } = useUser();
	const { message } = useConsultationMessage(id);
	const { toggleCopyModal } = useModalCopyMessage();

	const status = consultationStatus(consultation);

	// const hideMenu = status === 'cancelled' || status === 'awaitingPayment';
	const hideMenu = status === 'cancelled';

	const onMove = () =>
		navigate(
			`/consultations/${code}/choose-period/${JSON.stringify({
				consultationId: id,
				coachId: consultation?.coach.id,
				mode: consultation?.type,
			})}`
		);

	return hideMenu ? (
		<></>
	) : (
		<>
			<IconButton
				id="program-card-button"
				aria-controls={isOpen ? 'program-card-menu' : undefined}
				aria-haspopup="true"
				aria-expanded={isOpen ? 'true' : undefined}
				onClick={onOpen}
				variant="transparent"
			>
				<MoreHoriz />
			</IconButton>
			<Menu
				id="program-card-menu"
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				open={isOpen}
				onClose={onClose}
				onBlur={onClose}
				MenuListProps={{
					'aria-labelledby': 'program-card-button',
				}}
			>
				{(status === 'notPayed' || status === 'awaitingPayment') && !user?.is_coach && (
					<MenuItem
						sx={{ fontSize: '14px' }}
						onClick={(e) => {
							e.stopPropagation();
							onBuy();
						}}
					>
						Оплатить
					</MenuItem>
				)}

				{(status === 'notPayed' || status === 'awaitingPayment') && user?.is_coach && (
					<MenuItem
						sx={{ fontSize: '14px' }}
						onClick={(e) => {
							e.stopPropagation();
							toggleCopyModal(message);
						}}
					>
						Оповестить
					</MenuItem>
				)}
				{status === 'confirmed' && (
					<MenuItem
						sx={{ fontSize: '14px' }}
						onClick={(e) => {
							e.stopPropagation();
							onConnect();
						}}
					>
						Подключиться
					</MenuItem>
				)}
				{status === 'confirmed' && (
					<MenuItem
						sx={{ fontSize: '14px' }}
						onClick={(e) => {
							e.stopPropagation();
							onMove();
						}}
					>
						Перенести
					</MenuItem>
				)}
				{status === 'confirmed' && (
					<MenuItem
						sx={{ fontSize: '14px' }}
						onClick={(e) => {
							e.stopPropagation();
							onCancel();
						}}
					>
						Отменить
					</MenuItem>
				)}
			</Menu>
		</>
	);
};
